import {INFLUENCER_KEYS} from "@/api/influencerApi";
import TrashIcon from "@/assets/colorable/trash.svg?react";
import ConfirmationModal from "@/components/Common/ConfirmationModal";
import type {InfluencerFilterSerializer} from "@/generated/DjangoTypes";
import {client} from "@/httpClient";
import {queryClient} from "@/queryClient";
import {deleteFilterModalAtom} from "@/store/jotaiAtoms";
import type {TPaginated} from "@/store/types";
import {type InfiniteData, type Query, useMutation} from "@tanstack/react-query";
import type {AxiosResponse} from "axios";
import {produce} from "immer";
import {useAtom} from "jotai";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const DeleteFilterModal: FC = () => {
  const {t} = useTranslation(["influencer_list", "common"]);
  const [modalData, setModalData] = useAtom(deleteFilterModalAtom);

  const {mutate: deleteFilter, isPending} = useMutation({
    mutationKey: INFLUENCER_KEYS.mDeleteInfluencerFilter(modalData?.filterId!),
    mutationFn: () => client.delete(INFLUENCER_KEYS.mDeleteInfluencerFilter(modalData!.filterId)[0]),
    onSuccess: () => {
      const filterBasePath = INFLUENCER_KEYS.qInfluencerFilters({})[0].split("?")[0];
      const predicate = {
        predicate: (query: Query) =>
          typeof query.queryKey[0] === "string" && query.queryKey[0].startsWith(filterBasePath),
      };

      queryClient.setQueriesData<InfiniteData<AxiosResponse<TPaginated<InfluencerFilterSerializer>>>>(predicate, old =>
        old
          ? produce(old, draft => {
              for (const page of draft.pages) {
                page.data.results = page.data.results.filter(f => f.id !== modalData!.filterId);
              }
            })
          : old,
      );
      modalData?.onSuccess?.();
      setModalData(null);
    },
  });

  return (
    <ConfirmationModal
      Icon={TrashIcon}
      confirmButtonText={t("delete_filter")}
      description={t("delete_filter_description")}
      isPending={isPending}
      onClose={() => setModalData(null)}
      onConfirm={() => deleteFilter()}
      title={t("delete_filter_title")}
    />
  );
};

export default DeleteFilterModal;
